import { Component, OnInit, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ServiceRecordsService } from 'src/app/_services/service-records.service';
import { TechnicalViewService } from 'src/app/_services/technical-view.service';
import { VehiclesService } from 'src/app/_services/vehicles.service';
import { DialogService } from 'primeng/dynamicdialog';
import { CreateTechnicalrecordComponent } from './create-technicalrecord/create-technicalrecord.component';
import { IssuesService } from '../../../_services/issues.service';
import { ActiveIssueFormComponent } from '../../components/active-issues/active-issue-form/active-issue-form.component';
import { SignoffIssueComponent } from '../../components/active-issues/signoff-issue/signoff-issue.component';
import { ViewTechnicalComponent } from './view-technical/view-technical.component';
import { ViewJobComponent } from './view-job/view-job.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import {
  ActiveFilter,
  FILTER_OPERATORS,
  translateFiltersToRsql,
} from 'src/app/_models/table-filter.model';

type TechnicalRecordScope = 'all' | 'active' | 'archived';
type TechnicalRecordArchiveParam = 'all' | 'true' | 'false';

@Component({
  selector: 'app-technical',
  templateUrl: './technical.component.html',
  styleUrls: ['./technical.component.scss'],
})
export class TechnicalComponent implements OnInit {
  selectedVehicle: any = this.vehiclesService.selectedVehicle;
  vehicleTechnicalRecords: any[] = [];
  technicalRecords$ = this.technicalViewService.technicalRecords$;
  issues: any[] = [];
  ref: any;
  isLoading = false;
  technicalRecords: any[] = [];
  selectedDescription: any[] = [];
  transformedData: any[] = [];
  loading = false;
  totalRecords = 0;
  issueTotalRecords = 0;
  technicalData: any[] = [];
  expandedRows: any[] = [];
  page = 0;
  technicalRecordLimit = 1000;
  technicalPageSize = 25;
  issueRows = 5;
  currentPage = 0;
  issueData: any[] = [];
  issueFilter = '';
  currentIssuePage = 0;

  vehicles: any[] = [];

  // Filter builder state
  keyword = '';
  activeFilters: ActiveFilter[] = [];
  filterLogic: 'AND' | 'OR' = 'AND';
  showFilterPanel = false;
  downloadingExcel = false;

  pendingField = '';
  pendingOperator = '';
  pendingValue = '';

  readonly filterableFields = [
    { label: 'Vehicle Reference',  value: 'vehicle_reference' },
    { label: 'Record Type',        value: 'record_type' },
    { label: 'Odometer',           value: 'odometer' },
    { label: 'Date Completed',     value: 'date_completed' },
    { label: 'Chassis No',         value: 'chassis_no' },
    { label: 'Service Job No',     value: 'service_jobno' },
    { label: 'Service Type',       value: 'service_type' },
    { label: 'Tyre Position',      value: 'tyre_pos' },
    { label: 'Tyre Size',          value: 'tyre_size' },
    { label: 'Tyre Type',          value: 'tyre_type' },
    { label: 'Remarks',            value: 'remarks' },
    { label: 'Job Description',    value: 'technical_record_jobs.job_description' },
    { label: 'Job Remarks',        value: 'technical_record_jobs.remarks' },
  ];

  readonly filterOperators = FILTER_OPERATORS.map((op) => ({
    label: op.label,
    value: op.value,
  }));

  allTechnicalRecords: any[] = [];
  hasRecordMixChart = false;
  hasOdometerChart = false;
  lastRecordDate = 'N/A';
  latestOdometer = 'N/A';
  vehicleRecordTypeLegend: any[] = [];
  vehicleTechnicalTotal = 0;
  vehicleRecordMixChartData: any = {
    labels: [],
    datasets: [],
  };
  vehicleOdometerChartData: any = {
    labels: [],
    datasets: [],
  };
  vehicleRecordMixChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '66%',
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  
  private vehicleChartColors = [
    '#3b6ff6',
    '#55b578',
    '#f4ad37',
    '#df4e49',
    '#7d4bdd',
    '#4aa3df',
  ];

  expandedRowKeys: { [key: string]: boolean } = {};
  @ViewChild('dt') dt: Table | undefined;
  activeIssuesTable: any;
  recordTypeOptions: { label: string; value: TechnicalRecordScope }[] = [
    { label: 'All records', value: 'all' },
    { label: 'Active vehicles', value: 'active' },
    { label: 'Archived vehicles', value: 'archived' },
  ];
  pendingRecordType: TechnicalRecordScope = 'all';

  onRowExpand(event: any): void {
    // Clear other expanded rows when a new one is expanded
    this.expandedRowKeys = { [event.data.url]: true };
    // console.log('expanded row keys', this.expandedRowKeys);
  }

  onRowCollapse(event: any): void {
    // Remove the collapsed row from the expanded keys
    delete this.expandedRowKeys[event.data.url];
    // console.log('collapsed row keys', this.expandedRowKeys);
  }

  constructor(
    public vehiclesService: VehiclesService,
    public serviceRecords: ServiceRecordsService,
    public technicalViewService: TechnicalViewService,
    public dialogService: DialogService,
    public issueService: IssuesService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router
  ) {}

  columns = [
    { field: 'vehicle_reference', header: 'Vehicle Reference' },
    { field: 'record_type', header: 'Record Type' },
    { field: 'odometer', header: 'Odometer' },
    { field: 'date_completed', header: 'Date Completed' },
    { field: 'chassis_no', header: 'Chassis Number' },
  ];

  subColumns = [
    { field: 'service_type', header: 'Description' },
    { field: 'record_type', header: 'Record Type' },
    { field: 'description_tag', header: 'Jobs' },
  ];

  technicalColumns = [
    { field: 'vehicle_reference', header: 'Vehicle Reference' },
    { field: 'record_type', header: 'Record Type' },
    { field: 'date_completed', header: 'Date Completed' },
    { field: 'odometer', header: 'Odometer' },
    { field: 'description_tag', header: 'Jobs' },
  ];

  issueColumns = [{ field: 'description', header: 'Active Issues' }];

  private static readonly FILTER_STORAGE_KEY = 'technical_records_filter_state';

  private saveFilterState(): void {
    try {
      localStorage.setItem(
        TechnicalComponent.FILTER_STORAGE_KEY,
        JSON.stringify({
          keyword: this.keyword,
          activeFilters: this.activeFilters,
          filterLogic: this.filterLogic,
          pendingRecordType: this.pendingRecordType,
        })
      );
    } catch {}
  }

  private restoreFilterState(): void {
    try {
      const stored = localStorage.getItem(TechnicalComponent.FILTER_STORAGE_KEY);
      if (stored) {
        const state = JSON.parse(stored);
        this.keyword = state.keyword ?? '';
        this.activeFilters = state.activeFilters ?? [];
        this.filterLogic = state.filterLogic ?? 'AND';
        this.pendingRecordType = this.isTechnicalRecordScope(
          state.pendingRecordType
        )
          ? state.pendingRecordType
          : 'all';
      }
    } catch {}
  }

  private clearFilterState(): void {
    this.keyword = '';
    this.activeFilters = [];
    this.filterLogic = 'AND';
    this.pendingRecordType = 'all';
    try {
      localStorage.removeItem(TechnicalComponent.FILTER_STORAGE_KEY);
    } catch {}
  }

  ngOnInit(): void {
    this.loadVehicles();

    if (!this.selectedVehicle) {
      this.restoreFilterState();
      // The global table is lazy: PrimeNG fires (onLazyLoad) on init, which
      // calls loadTechnicalRecords for the first page — no explicit call here
      // (that would double-load).
      return;
    }

    this.loadVehicleTechnicalRecords();
    this.loadActiveIssues({ first: 0, rows: this.issueRows });
    this.isLoading = false;
  }

  getNumberofColumns() {
    return this.columns.length;
  }

  // Server-side (lazy) pagination for the global technical-records table:
  // fetch only the requested page from the API, so all ~8k records are
  // reachable by paging rather than capped at the first slice. (A specific
  // vehicle's records, by contrast, are pulled in full — see the app-table.)
  loadTechnicalRecords(
    event: any = { first: this.currentPage, rows: this.technicalPageSize }
  ) {
    this.loading = true;
    this.isLoading = true;

    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.technicalPageSize;
    this.currentPage = first;
    this.technicalPageSize = rows;
    const page = Math.floor(first / rows) + 1;

    const rsqlFilters = this.getTechnicalRecordFilters();
    const archiveScope = this.getArchiveScopeParam();

    this.technicalViewService
      .getTechnicalRecords(
        page,
        rows,
        this.keyword,
        rsqlFilters,
        archiveScope
      )
      .subscribe(
        (data: any) => {
          const responseBody = data?.body || {};

          this.totalRecords = responseBody.total_records || 0;
          this.allTechnicalRecords = responseBody.records || [];
          this.technicalViewService.updateTechnicalRecords(
            this.allTechnicalRecords
          );
          this.loading = false;
          this.isLoading = false;
        },
        (err) => {
          this.allTechnicalRecords = [];
          this.totalRecords = 0;
          this.loading = false;
          this.isLoading = false;
        }
      );
  }

  loadActiveIssues(
    event: any = { first: this.currentIssuePage, rows: this.issueRows }
  ) {
    this.loading = true;
    this.isLoading = true;

    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.issueRows;
    const page = Math.floor(first / rows) + 1;

    this.currentIssuePage = first;

    this.page = page;
    this.issueRows = rows;

    const vehicleId =
      this.selectedVehicle?.id || this.selectedVehicle?.vehicle_id;

    if (!vehicleId) {
      this.issueData = [];
      this.issueTotalRecords = 0;
      this.loading = false;
      this.isLoading = false;
      return;
    }

    this.issueService
      .getActiveIssueByVehicleId(vehicleId, page, rows, this.issueFilter)
      .subscribe(
        (data: any) => {
          const responseBody = data?.body || {};
          console.log('Active Issues Response', responseBody);
          
          this.issueData = this.transformData(responseBody.records || []);
          this.issueTotalRecords = responseBody.total_records || 0;
          this.loading = false;
          this.isLoading = false;
        },
        () => {
          this.issueData = [];
          this.issueTotalRecords = 0;
          this.loading = false;
          this.isLoading = false;
        }
      );
  }

  loadVehicles() {
    this.vehiclesService.getAllVehicles().subscribe((data: any) => {
      this.vehicles = this.withSelectedVehicleOption(data.body || []);
    });
  }

  confirmActiveIssueDelete(description: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this issue?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',

      accept: () => {
        this.deleteDescription(description);
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Rejected',
          detail: 'Record not deleted',
          key: 'active_issues',
        });
      },
    });
  }

  confirmMultiDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete these issues?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',

      accept: () => {
        this.deleteMultipleDescriptions();
      },
    });
  }

  deleteDescription(description: any): void {
    this.issueService.deleteActiveIssue(description.id).subscribe({
      next: () => {
        this.loadActiveIssues({
          first: this.currentIssuePage,
          rows: this.issueRows,
        });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Record deleted',
          key: 'active_issues',
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete record',
          key: 'active_issues',
        });
      },
    });
  }

  deleteMultipleDescriptions(): void {
    const toDelete = [...this.selectedDescription];
    this.selectedDescription = [];
    if (!toDelete.length) {
      return;
    }

    forkJoin(
      toDelete.map((description) =>
        this.issueService.deleteActiveIssue(description.id)
      )
    ).subscribe({
      next: () => {
        this.loadActiveIssues({
          first: this.currentIssuePage,
          rows: this.issueRows,
        });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `${toDelete.length} record(s) deleted`,
          key: 'active_issues',
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete one or more records',
          key: 'active_issues',
        });
      },
    });
  }

  deselectVehicle() {
    this.selectedVehicle = null;
    this.vehiclesService.selectedVehicle = null;
    this.currentIssuePage = 0;
    this.selectedDescription = [];
    this.issueData = [];
    this.issueTotalRecords = 0;
    this.issueFilter = '';
    localStorage.removeItem('selectedVehicle');
    this.resetVehicleInsights();
    this.loadTechnicalRecords();
  }

  openCreateTechnicalRecordDialog() {
    const ref = this.dialogService.open(CreateTechnicalrecordComponent, {
      header: 'Create Technical Record',
      width: '70%',
      styleClass: 'update-record-dialog-shell',
      data: this.selectedVehicle,
    });

    ref.onClose.subscribe((data) => {
      // console.log('Dialog closed', data);

      if (data) {
        this.technicalViewService.triggerReload();
        this.loadVehicleTechnicalRecords();
      }
    });
  }

  showEditActiveIssueModal(activeIssue: any) {
    var temp = [];
    //was my issue && activeIssue.length > 1
    if (Array.isArray(activeIssue)) {
      // If activeIssue is already an array, use it as is.
      temp = activeIssue;
    } else {
      // Otherwise, wrap it in an array.
      temp.push(activeIssue);
    }
    this.ref = this.dialogService.open(ActiveIssueFormComponent, {
      data: {
        formdata: temp,
      },
      header: 'Edit Active Issue',
      width: '75%',
      styleClass: 'update-record-dialog-shell',
      closeOnEscape: true,
    });

    this.ref.onClose.subscribe((result: any) => {
      this.clearActiveIssueSelection();

      if (result) {
        this.loadActiveIssues({
          first: this.currentIssuePage,
          rows: this.issueRows,
        });
      }
    });
  }

  clearActiveIssueSelection() {
    this.selectedDescription = [];
  }

  private setSelectedVehicle(vehicle: any) {
    this.vehiclesService.selectedVehicle = vehicle;
    this.selectedVehicle = vehicle;
    this.vehicles = this.withSelectedVehicleOption(this.vehicles);
    this.currentIssuePage = 0;
    this.selectedDescription = [];
    // Without this, a search typed while viewing one vehicle's active
    // issues silently carried over and filtered the next vehicle's list
    // too, with no visible indicator (the input wasn't even bound to
    // issueFilter, so it couldn't be cleared from the UI either).
    this.issueFilter = '';
    localStorage.setItem(
      'selectedVehicle',
      JSON.stringify(this.selectedVehicle)
    );
    this.clearFilterState();
    this.loadVehicleTechnicalRecords();
    this.loadActiveIssues({ first: 0, rows: this.issueRows });
  }

  private withSelectedVehicleOption(vehicles: any[]): any[] {
    if (!this.selectedVehicle) {
      return vehicles;
    }

    const selectedVehicleKey = this.getVehicleKey(this.selectedVehicle);

    if (
      !selectedVehicleKey ||
      vehicles.some(
        (vehicle) => this.getVehicleKey(vehicle) === selectedVehicleKey
      )
    ) {
      return vehicles;
    }

    return [this.selectedVehicle, ...vehicles];
  }

  private getVehicleKey(vehicle: any): string | null {
    const vehicleId = vehicle?.id ?? vehicle?.vehicle_id;

    if (vehicleId !== null && vehicleId !== undefined) {
      return `id:${vehicleId}`;
    }

    return vehicle?.vehicle_reference
      ? `ref:${vehicle.vehicle_reference}`
      : null;
  }

  onVehicleSelect($event: any) {
    const vehicle = $event?.value;

    if (!vehicle) {
      this.deselectVehicle();
      return;
    }

    this.setSelectedVehicle(vehicle);
  }

  showSelectedVehicle(record: any) {
    const vehicleId = record?.vehicle_id;

    if (vehicleId) {
      this.vehiclesService.getVehicleById(vehicleId).subscribe((data: any) => {
        this.setSelectedVehicle(data.body);
      });
      return;
    }

    const vehicleReference = record?.vehicle_reference;

    if (vehicleReference) {
      this.vehiclesService
        .getVehicleByReference(vehicleReference)
        .subscribe((data: any) => {
          this.setSelectedVehicle(data.body);
        });
    }
  }

  showSignOffModal(activeIssue: any, description: any) {
    this.ref = this.dialogService.open(SignoffIssueComponent, {
      data: {
        data: activeIssue,
        descriptionData: description,
      },
      header: 'Sign Off Issue',
      width: '70%',
      height: '70%',
      styleClass: 'update-record-dialog-shell',
      closeOnEscape: true,
    });

    this.ref.onClose.subscribe((result: any) => {
      this.clearActiveIssueSelection();
      if (result) {
        this.technicalViewService.triggerReload();
        this.loadActiveIssues({
          first: this.currentIssuePage,
          rows: this.issueRows,
        });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Issue signed off successfully',
          key: 'active_issues',
        });
      }
    });
  }

  openViewTechnicalRecordDialog(data: any) {
    const ref = this.dialogService.open(ViewTechnicalComponent, {
      header: 'View Technical Record',
      width: '70%',
      data: {
        technicalRecord: data,
        vehicleData: this.selectedVehicle,
      },
    });

    ref.onClose.subscribe((data) => {
      // console.log('Dialog closed', data);
    });
  }

  onJobSelect($event: any) {
    const ref = this.dialogService.open(ViewJobComponent, {
      header: 'View Job',
      width: '70%',
      data: $event,
    });
  }

  transformData(issues: any[]): any[] {
    return issues
      .map((issue: any) => ({
        ...issue,
        descriptions: [
          {
            id: issue.id,
            description: issue.description,
            vehicle_reference: issue.vehicle_reference,
            remarks: issue.remarks,
            vehicle_id: issue.vehicle_id,
          },
        ],
      }));
  }

  handleCellClick(event: Event): void {
    event.stopPropagation();
  }

  filterActiveIssues(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.issueFilter = inputElement.value.trim();
    this.currentIssuePage = 0;
    this.loadActiveIssues({ first: 0, rows: this.issueRows });
  }

  clearActiveIssueFilter() {
    this.issueFilter = '';
    this.currentIssuePage = 0;
    this.loadActiveIssues({ first: 0, rows: this.issueRows });
  }

  filterGlobal($event: any) {
    const inputElement = $event.target as HTMLInputElement;
    this.keyword = inputElement.value.trim();
    this.currentPage = 0;
    this.saveFilterState();
    this.loadTechnicalRecords();
  }

  get selectedRecordTypeLabel(): string {
    return (
      this.recordTypeOptions.find(
        (option) => option.value === this.pendingRecordType
      )?.label ?? 'All records'
    );
  }

  onRecordTypeChange(): void {
    this.currentPage = 0;
    this.saveFilterState();
    this.loadTechnicalRecords();
  }

  clearRecordTypeFilter(): void {
    this.pendingRecordType = 'all';
    this.onRecordTypeChange();
  }

  addFilter() {
    if (!this.pendingField || !this.pendingOperator || !this.pendingValue.trim()) return;

    const field = this.filterableFields.find((f) => f.value === this.pendingField);
    const op = this.filterOperators.find((o) => o.value === this.pendingOperator);

    this.activeFilters = [
      ...this.activeFilters,
      {
        field: this.pendingField,
        fieldLabel: field?.label ?? this.pendingField,
        operator: this.pendingOperator,
        operatorLabel: op?.label ?? this.pendingOperator,
        value: this.pendingValue.trim(),
        source: 'builder',
      },
    ];

    this.pendingValue = '';
    this.saveFilterState();
    this.loadTechnicalRecords();
  }

  removeFilter(index: number) {
    this.activeFilters = this.activeFilters.filter((_, i) => i !== index);
    this.saveFilterState();
    this.loadTechnicalRecords();
  }

  clearFilters() {
    this.clearFilterState();
    this.loadTechnicalRecords();
  }

  onFilterLogicChange() {
    this.saveFilterState();
    if (this.activeFilters.length > 0) {
      this.loadTechnicalRecords();
    }
  }

  downloadExcel() {
    this.downloadingExcel = true;
    const rsqlFilters = this.getTechnicalRecordFilters();
    const archiveScope = this.getArchiveScopeParam();

    this.technicalViewService
      .downloadTechnicalRecords(
        this.keyword,
        rsqlFilters,
        'xlsx',
        archiveScope
      )
      .subscribe(
        (response: any) => {
          const disposition = response.headers.get('Content-Disposition') ?? '';
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          const fileName = match ? match[1].replace(/['"]/g, '') : 'technical_records.xlsx';

          const blob: Blob = response.body as Blob;
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(a.href);
          this.downloadingExcel = false;
        },
        () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Download failed',
            detail: 'Could not download the Excel report',
            key: 'technical',
          });
          this.downloadingExcel = false;
        }
      );
  }

  private getTechnicalRecordFilters(): string[] {
    return translateFiltersToRsql(
      this.activeFilters,
      this.filterLogic
    );
  }

  private getArchiveScopeParam(): TechnicalRecordArchiveParam {
    if (this.pendingRecordType === 'active') {
      return 'false';
    }

    if (this.pendingRecordType === 'archived') {
      return 'true';
    }

    return 'all';
  }

  private isTechnicalRecordScope(value: any): value is TechnicalRecordScope {
    return ['all', 'active', 'archived'].includes(value);
  }

  private loadVehicleTechnicalRecords(): void {
    const vehicleId =
      this.selectedVehicle?.id || this.selectedVehicle?.vehicle_id;

    if (!vehicleId) {
      this.vehicleTechnicalRecords = [];
      this.resetVehicleInsights();
      return;
    }

    this.technicalViewService
      .getTechnicalRecordsByVehicleId(
        String(vehicleId),
        1,
        this.technicalRecordLimit
      )
      .subscribe(
        (data: any) => {
          const responseBody = data?.body || {};
          const records = Array.isArray(responseBody)
            ? responseBody
            : responseBody.records || [];

          this.vehicleTechnicalRecords = records;
          this.updateVehicleInsights(records);
        },
        () => {
          this.vehicleTechnicalRecords = [];
          this.resetVehicleInsights();
        }
      );
  }

  private resetVehicleInsights(): void {
    this.hasRecordMixChart = false;
    this.hasOdometerChart = false;
    this.lastRecordDate = 'N/A';
    this.latestOdometer = 'N/A';
    this.vehicleRecordTypeLegend = [];
    this.vehicleTechnicalTotal = 0;
    this.vehicleRecordMixChartData = {
      labels: [],
      datasets: [],
    };
    this.vehicleOdometerChartData = {
      labels: [],
      datasets: [],
    };
  }

  private updateVehicleInsights(records: any[]): void {
    const sortedRecords = [...records].sort(
      (a: any, b: any) =>
        this.getRecordTime(a?.date_completed) -
        this.getRecordTime(b?.date_completed)
    );
    const datedRecords = sortedRecords.filter(
      (record: any) => !!record?.date_completed
    );
    const latestRecord =
      datedRecords.length > 0
        ? datedRecords[datedRecords.length - 1]
        : sortedRecords[sortedRecords.length - 1];

    this.vehicleTechnicalTotal = records.length;
    this.lastRecordDate = latestRecord?.date_completed
      ? this.formatDate(latestRecord.date_completed)
      : 'N/A';

    this.updateRecordMixChart(records);
    this.updateOdometerChart(sortedRecords);
  }

  private updateRecordMixChart(records: any[]): void {
    const recordTypeCounts = records.reduce((counts: any, record: any) => {
      const raw = record?.record_type || 'Unspecified';
      const label = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
      counts[label] = (counts[label] || 0) + 1;
      return counts;
    }, {});
    const entries = Object.entries(recordTypeCounts).sort(
      (a: any, b: any) => b[1] - a[1]
    );

    this.hasRecordMixChart = entries.length > 0;
    this.vehicleRecordTypeLegend = entries.map(
      ([label, value]: any, index: number) => ({
        label,
        value,
        percentage: `${Math.round((value / records.length) * 100)}%`,
        color: this.vehicleChartColors[index % this.vehicleChartColors.length],
      })
    );
    this.vehicleRecordMixChartData = {
      labels: this.vehicleRecordTypeLegend.map((item) => item.label),
      datasets: [
        {
          data: this.vehicleRecordTypeLegend.map((item) => item.value),
          backgroundColor: this.vehicleRecordTypeLegend.map(
            (item) => item.color
          ),
          hoverBackgroundColor: this.vehicleRecordTypeLegend.map(
            (item) => item.color
          ),
          borderColor: '#ffffff',
          borderWidth: 4,
        },
      ],
    };
  }

  private updateOdometerChart(records: any[]): void {
    const odometerPoints = records
      .map((record: any) => ({
        label: this.formatDate(record?.date_completed),
        value: this.parseNumber(record?.odometer),
      }))
      .filter((point: any) => Number.isFinite(point.value));
    const latestPoint = odometerPoints[odometerPoints.length - 1];

    this.latestOdometer = latestPoint
      ? this.formatNumber(latestPoint.value)
      : 'N/A';
    this.hasOdometerChart = odometerPoints.length > 1;
    this.vehicleOdometerChartData = {
      labels: odometerPoints.map((point: any) => point.label),
      datasets: [
        {
          label: 'Odometer',
          data: odometerPoints.map((point: any) => point.value),
          borderColor: '#3b6ff6',
          backgroundColor: 'rgba(59, 111, 246, 0.12)',
          fill: true,
          tension: 0.35,
          pointBackgroundColor: '#ffffff',
          pointBorderColor: '#3b6ff6',
          pointBorderWidth: 2,
          pointRadius: 3,
          pointHoverRadius: 5,
        },
      ],
    };
  }

  private getRecordTime(value: any): number {
    if (!value) {
      return 0;
    }

    const date = new Date(value);
    const time = date.getTime();

    return Number.isNaN(time) ? 0 : time;
  }

  private parseNumber(value: any): number {
    if (typeof value === 'number') {
      return value;
    }

    if (!value) {
      return Number.NaN;
    }

    const parsed = Number(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : Number.NaN;
  }

  private formatNumber(value: number): string {
    return new Intl.NumberFormat('en-ZA', {
      maximumFractionDigits: 0,
    }).format(value);
  }

  private formatDate(value: any): string {
    if (!value) {
      return 'N/A';
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return new Intl.DateTimeFormat('en-ZA', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(date);
  }
}
